import { render, staticRenderFns } from "./AddRmaProductForm.vue?vue&type=template&id=4a5aacf4&"
import script from "./AddRmaProductForm.vue?vue&type=script&lang=js&"
export * from "./AddRmaProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports